var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinancial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2716 0H1.77503C0.79029 0 0.00891975 0.845278 0.00891975 1.88889L0 15.1111C0 16.1538 0.79029 17 1.77503 17H14.2716C15.2572 17 16.0556 16.1538 16.0556 15.1111V1.88889C16.0556 0.845278 15.2572 0 14.2716 0ZM14.2711 11.3333H10.7032C10.7032 12.8983 9.50527 14.1667 8.02727 14.1667C6.54927 14.1667 5.35134 12.8983 5.35134 11.3333H1.77452V1.88889H14.2711V11.3333Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinancial);
export default __webpack_public_path__ + "static/media/financial.228e4281.svg";
export { ForwardRef as ReactComponent };